import { PriceRecommendationState } from '@app/model/market_state/PriceRecommendationState';

export default class PriceRecommendationStateSnapshot {
	recommendation: PriceRecommendationState;
	isSubmitted: boolean;
	hasRecommendation: boolean;
	recommendedPrice: number;
	effectiveChangeRate: number;
	recommendationPosition: number;

	constructor(data: PriceRecommendationStateSnapshot) {
		if (!!data.recommendation)
			this.recommendation = new PriceRecommendationState(data.recommendation);
		this.isSubmitted = data.isSubmitted;
		this.recommendationPosition = data.recommendationPosition;
		this.hasRecommendation = data.hasRecommendation;
		this.effectiveChangeRate = data.effectiveChangeRate;
		this.recommendedPrice = data.recommendedPrice;
	}

	hasValidRecommendation() {
		return !!this.recommendation && this.recommendation.isValid;
	}

	isAdjusted() {
		return !!this.recommendation && this.recommendation.effectiveChangeRate !== this.recommendation.recommendedChangeRate;
	}
}
